import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 20px;
  margin-left: ${({direction}) =>
    direction === 'horizontal' ? '2rem !important' : 'initial'};
`;
